import { StateManager } from '../../store/StateManager';
import { OptionItem, PropInfo, Section } from "./TextSection";
import { SectionBase } from "./SectionBase";

// export interface IOptionsSection extends Section {
//     options: Array<{label: string, selected: boolean}>;
//     value: string[];
// }

export class OptionsSection extends SectionBase {
    public options: OptionItem[]
    public value: string[];

    constructor(section:Section) {
        super(section);
        this.options = section.options as OptionItem[] || [];
        this.value = section.value || [];
    }
    clone() {
        return new OptionsSection(this.toJSON());
    }

    render(): HTMLDivElement {
        const wrapper = document.createElement('div');
        wrapper.tabIndex =-1;
        wrapper.classList.add('wrapper');
        const container = document.createElement('div');
        container.classList.add('section', 'options-section');
        container.tabIndex =-1;
        container.style.fontFamily = 'inherit'
        container.focus();

        const grid = document.createElement('div');
        grid.style.fontFamily = 'inherit'
        grid.classList.add('options-grid');

        this.options.forEach((option, index) => {
            const optionContainer = document.createElement('div');
            optionContainer.classList.add('option-container');
            
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.id = option.label;
            checkbox.checked = option.isCorrect;
            checkbox.addEventListener('change', (e) => this.handleOptionChange(index, (e.target as HTMLInputElement).checked));
            
            const label = document.createElement('label');
            label.style.fontFamily = 'inherit'
            label.htmlFor = checkbox.id;
            label.textContent = option.showLabel ? option.label : '';
            if(option.labelMaxWidth && Number(option.labelMaxWidth)){
                const stateManger = StateManager.getInstance();
                const state = stateManger.getState();        
                optionContainer.style.width = `calc(${Number(option.labelMaxWidth)}% - 2px)`;
                label.style.whiteSpace = 'normal';                
            }            
            else{
                optionContainer.style.width = `calc(100% - 2px)`;      
            }
            optionContainer.style.fontFamily = 'inherit'
            optionContainer.appendChild(checkbox);
            optionContainer.appendChild(label);
            grid.appendChild(optionContainer);
        });
        
        container.appendChild(grid);
        wrapper.appendChild(container);
        return wrapper;
    }

    private handleOptionChange(index: number, checked: boolean) {
        this.options[index].isCorrect = checked;
        this.value = this.options
            .filter(opt => opt.isCorrect)
            .map(opt => opt.label);

        const stateManager = StateManager.getInstance();
        const oldState = stateManager.getState();
        stateManager.setState({
            state: {
                ...oldState,
                sections:oldState.sections.map(section => 
                    section.id === this.id ? this.toJSON() : section
                )
            },
            changeType: 'updateSection'
        });
    }
}
